












































































































import { Component, Vue } from 'vue-property-decorator'
import { Share, ShareType } from '@/api/model/share'
import { CompanyAPI, ShareAPI } from '@/api/backend-client'
import { OrderType, orderTypes, ReferralType } from '@/api/types'
import { v4 as uuid } from 'uuid'
import { ReferralNode } from '@/api/model/referral-node'

@Component
    export default class SharesEditSharesLegacy extends Vue {
        loading: boolean = false
        shares: Share[] = []
        incoming: ReferralNode[] = []

        async mounted(): Promise<void> {
            await this.loadShares()
            await this.ensureSharesAreCreated()
        }

        readSharePercentage(type: string, orderType: string|null, referralType: string|null): string|null {
            let entry = null

            if (orderType !== null) {
                entry = this.shares.find(share => share.type === type && share.orderType === orderType)
            } else if (referralType !== null) {
                entry = this.shares.find(share => share.type === type && share.referralType === referralType)
            }

            return entry ? entry.percentage : '0'
        }

        async updateSharePercentage(type: string, orderType: string, referralType: string|null, percentage: string): Promise<void> {
            let index = null

            if (orderType !== null) {
                index = this.shares.findIndex(share => share.type === type && share.orderType === orderType)
            } else if (referralType !== null) {
                index = this.shares.findIndex(share => share.type === type && share.referralType === referralType)
            }

            this.shares[index].percentage = percentage
        }

        async loadShares(): Promise<void> {
            this.loading = true
            this.shares = await ShareAPI.getAll()
            this.incoming = await CompanyAPI.getIncomingReferrals()
            this.loading = false
        }

        async saveShares(): Promise<void> {
            this.loading = true
            for (const share of this.shares) {
                await ShareAPI.update(share.id, share)
            }
            await this.loadShares()
            this.loading = false
        }

        async ensureSharesAreCreated(): Promise<void> {
            this.loading = true

            if (this.ordersEnabled) {
                for (const orderType of this.filteredOrderTypes) {
                    const hasInternal = this.shares.some(share => share.type === ShareType.INTERNAL && share.orderType === orderType)
                    const hasExternal = this.shares.some(share => share.type === ShareType.EXTERNAL && share.orderType === orderType)

                    if (!hasInternal) {
                        await ShareAPI.create(new Share(
                            this.$currentCompany,
                            uuid(),
                            ShareType.INTERNAL,
                            orderType,
                            null,
                            null,
                            '20',
                        ))
                    }

                    if (!hasExternal) {
                        await ShareAPI.create(new Share(
                            this.$currentCompany,
                            uuid(),
                            ShareType.EXTERNAL,
                            orderType,
                            null,
                            null,
                            '20',
                        ))
                    }
                }
            } else {
                for (const referralNodeType of this.filteredReferralNodeTypes) {
                    const hasExternal = this.shares.some(share => share.type === ShareType.EXTERNAL && share.referralType === referralNodeType.value)

                    if (!hasExternal) {
                        await ShareAPI.create(new Share(
                            this.$currentCompany,
                            uuid(),
                            ShareType.EXTERNAL,
                            null,
                            referralNodeType.value as ReferralType,
                            null,
                            '20',
                        ))
                    }
                }
            }

            await this.loadShares()
            this.loading = false
        }

        get filteredOrderTypes(): OrderType[] {
            return orderTypes().filter(orderType => {
              return this.$currentCompany.orderSettings.enabledTypes
                  .includes(orderType)
            })
        }

        get availableOrderTypes(): Array<{ label: string, value: string }> {
            return this.filteredOrderTypes.map(orderType => {
                return {
                    label: this.$t(`order.type.${orderType}`).toString(),
                    value: orderType,
                }
            })
        }

        get availableIncomingReferralNodeType(): ReferralNode[] {
            return this.incoming.filter(node => {
                return node.source.id !== this.$currentCompany.id
                    || node.target.id !== this.$currentCompany.id
            })
        }

        get filteredReferralNodeTypes(): Array<{ label: string, value: string }> {
            const referralTypes = this.availableIncomingReferralNodeType
                .map(node => node.type)

            return [...new Set(referralTypes)].map(type => {
                return {
                    label: this.$t(`referral.type.${type}`).toString(),
                    value: type,
                }
            })
        }

        get ordersEnabled(): boolean {
            return this.$currentCompany.orderSettings && this.$currentCompany.orderSettings.enabled
        }
    }
